// extracted by mini-css-extract-plugin
export default {"species":"Species_species__qYdeJ","species-without-info":"Species_species-without-info__4g2Aq"};